module.exports = __webpack_public_path__ + "static/movie-01-de2a472a2e698717dcdc4e81ce313c25.mp4";